import { useRef, useState, useMemo, useCallback } from 'react';
import { getRelativeCursor as Fi } from '../../core/dist/nivo-core.es.js';
import '../../../d3-array/dist/d3-array.js';
import '../../../d3-interpolate/dist/d3-interpolate.js';
import './../../../d3-scale/external_lib/d3-format/src/defaultLocale.js';
import './../../../d3-scale/external_lib/d3-format/src/formatSpecifier.js';
import '../../../d3-time/src/millisecond.js';
import '../../../d3-time/src/second.js';
import '../../../d3-time/src/minute.js';
import '../../../d3-time/src/hour.js';
import '../../../d3-time/src/day.js';
import '../../../d3-time/src/week.js';
import '../../../d3-time/src/month.js';
import '../../../d3-time/src/year.js';
import '../../../d3-time/src/utcMinute.js';
import '../../../d3-time/src/utcHour.js';
import '../../../d3-time/src/utcDay.js';
import '../../../d3-time/src/utcWeek.js';
import '../../../d3-time/src/utcMonth.js';
import '../../../d3-time/src/utcYear.js';
import '../../../d3-time-format/src/defaultLocale.js';
import '../../../d3-time-format/src/isoFormat.js';
import '../../../d3-time-format/src/isoParse.js';
import Delaunay from '../../../d3-delaunay/src/delaunay.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
var g = function (n) {
    return "function" == typeof n ? n : function (e) {
      return e[n];
    };
  },
  b = function (n) {
    var e = n.points,
      i = n.x,
      o = void 0 === i ? "x" : i,
      t = n.y,
      r = void 0 === t ? "y" : t,
      l = g(o),
      u = g(r);
    return e.map(function (n) {
      return [l(n), u(n)];
    });
  },
  k = function (n) {
    var e = n.points,
      i = n.width,
      o = n.height,
      t = n.debug,
      r = Delaunay.from(e),
      l = t ? r.voronoi([0, 0, i, o]) : void 0;
    return {
      delaunay: r,
      voronoi: l
    };
  },
  x = function (e) {
    var i = e.points,
      o = e.x,
      t = e.y,
      r = e.width,
      l = e.height,
      u = e.debug,
      a = useMemo(function () {
        return b({
          points: i,
          x: o,
          y: t
        });
      }, [i, o, t]);
    return useMemo(function () {
      return k({
        points: a,
        width: r,
        height: l,
        debug: u
      });
    }, [a, r, l, u]);
  },
  O = function (e) {
    var i = e.nodes,
      l = e.width,
      u = e.height,
      a = e.x,
      d = e.y,
      c = e.onMouseEnter,
      h = e.onMouseMove,
      m = e.onMouseLeave,
      y = e.onClick,
      g = e.debug,
      b = useRef(null),
      k = useState(null),
      C = k[0],
      L = k[1],
      w = x({
        points: i,
        x: a,
        y: d,
        width: l,
        height: u,
        debug: g
      }),
      W = w.delaunay,
      D = w.voronoi,
      M = useMemo(function () {
        if (g && D) return D.render();
      }, [g, D]),
      O = useCallback(function (n) {
        if (!b.current) return [null, null];
        var e = Fi(b.current, n),
          o = e[0],
          t = e[1],
          r = W.find(o, t);
        return [r, void 0 !== r ? i[r] : null];
      }, [b, W]),
      P = useCallback(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == c || c(o, n));
      }, [O, L, c]),
      j = useCallback(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == h || h(o, n));
      }, [O, L, h]),
      S = useCallback(function (n) {
        if (L(null), m) {
          var e = void 0;
          null !== C && (e = i[C]), e && m(e, n);
        }
      }, [L, C, m, i]),
      z = useCallback(function (n) {
        var e = O(n),
          i = e[0],
          o = e[1];
        L(i), o && (null == y || y(o, n));
      }, [O, L, y]);
    return jsxs("g", {
      ref: b,
      children: [g && D && jsxs(Fragment, {
        children: [jsx("path", {
          d: M,
          stroke: "red",
          strokeWidth: 1,
          opacity: .75
        }), null !== C && jsx("path", {
          fill: "pink",
          opacity: .35,
          d: D.renderCell(C)
        })]
      }), jsx("rect", {
        width: l,
        height: u,
        fill: "red",
        opacity: 0,
        style: {
          cursor: "auto"
        },
        onMouseEnter: P,
        onMouseMove: j,
        onMouseLeave: S,
        onClick: z
      })]
    });
  },
  P = function (n, e) {
    n.save(), n.globalAlpha = .75, n.beginPath(), e.render(n), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
  },
  j = function (n, e, i) {
    n.save(), n.globalAlpha = .35, n.beginPath(), e.renderCell(i, n), n.fillStyle = "red", n.fill(), n.restore();
  };
export { O as Mesh, k as computeMesh, b as computeMeshPoints, j as renderVoronoiCellToCanvas, P as renderVoronoiToCanvas, x as useVoronoiMesh };
//# sourceMappingURL=nivo-voronoi.es.js.map
